module.exports = __webpack_public_path__ + "static/img/row9.db394e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row9.png
// module id = VYVW
// module chunks = 12